import { Base } from './_base.model';

export class EventTour extends Base {
  id: number;
  speaker_id: string;
  event_id: string;
  tour_event_id: string;
}